import React, {useEffect, useContext} from 'react'
import {Box, Typography, Button} from '@material-ui/core'
import {ReservationContext} from './../../../context/Reservation'
import './StepConfirmedReservation.styles.scss'
export default function StepConfirmedReservation({onClose, id}) {
  useEffect(() => {
    setTimeout(() => {
      onClose()
    }, 3000)
  }, [onClose])

  const {reservations} = useContext(ReservationContext)
  return (
    <>
      <div className="c-res-mod ap-modal" style={{width: 277, height: 156, padding: 0}}>
        <Box className="c-confirm-pop-up">
          <Typography className="ap-typography ap-typography--lg c-res-completed">
            Reservation Completed!
          </Typography>
          <Typography className="ap-typography ap-typography--sm c-res-completion-id">
            {`Reservation #${reservations?.data?.reservation_uid}`}
          </Typography>
          <Button
            className="ap-button ap-button--primary c-res-completion-button"
            onClick={() => {
              onClose()
            }}
          >
            OK
          </Button>
        </Box>
      </div>
    </>
  )
}
